'use client';

import { RadioButtonVariant, RadioField } from '@/components/input';
import { Text } from '@/components/text';

import type { FilteringSchemaType } from './form-schema';
import type { ElectricityDistributorSchema } from '@energy-retailer/schema';
import type { ComponentProps } from 'react';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';
import { EnergyType } from '@energy-retailer/constants';

type DistributorFieldProps = {
  heading?: string;
  labelVariant?: ComponentProps<typeof Text>['variant'];
  labelAs?: ComponentProps<typeof Text>['as'];
};

const DistributorField = ({
  labelVariant = 'h3',
  labelAs = 'h3',
  heading,
}: DistributorFieldProps) => {
  const { steps, currentStepNumber, property: { electricityDistributors, gasDistributors } } = useJoinFormStore();

  return (
    <>
      {heading ? (
        <Text
          variant={labelVariant}
          as={labelAs}
        >
          {heading}
        </Text>
      ) : null}
      <RadioField<FilteringSchemaType>
        name="distributor"
        variant={RadioButtonVariant.RIGHT}
        defaultValue={
          steps[currentStepNumber]?.fuel === EnergyType.Electricity
            ? electricityDistributors[0].id
            : gasDistributors[0].id
        }
        options={
          steps[currentStepNumber]?.fuel === EnergyType.Electricity
            ? electricityDistributors.map(
              (value: ElectricityDistributorSchema) => ({
                id: value.id,
                name: value.name,
                image: value.image,
              })
            )
            : gasDistributors.map((value) => ({
              id: value.id,
              name: value.name,
              image: value.image,
            }))
        }
      />
    </>
  );
};

export { DistributorField };
